import { RootState } from "src/features/visitorCashier/imports/types";

export const visitorCashierSelectors = {
  getVisitorOffers: (state: RootState) => state.visitorCashier.visitorOffers,
  getMarketingOffers: (state: RootState) => state.visitorCashier.offers,
  getIsBuyOfferAfterLogin: (state: RootState) =>
    state.visitorCashier.isBuyOfferAfterLogin,
  getSelectedOffer: (state: RootState) => state.visitorCashier.selectedOffer,
};
